import { registerPlugin } from "@capacitor/core";

import type { MobileServicesPlugin } from "./definitions";

const MobileServices = registerPlugin<MobileServicesPlugin>("MobileServices", {
  web: () => import("./web").then((m) => new m.MobileServicesWeb()),
});

export * from "./definitions";
export { MobileServices };
